var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<loading ng-if=\"!$ctrl.assignment && !$ctrl.errorLoading\">Loading...</loading>\n<pkp-alert type=\"danger\" ng-if=\"$ctrl.errorLoading\">\nThe page could not be loaded, please try again later.\n</pkp-alert>\n<div ng-if=\"$ctrl.assignment\">\n<pkp-shippers-details-credit-limits assignment=\"$ctrl.assignment\">\n</pkp-shippers-details-credit-limits>\n</div>\n";
var id1="app/shippers/shippers-details.component.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;